import React from "react";
import "./BackToGamesButton.css";

// Turns "#e85a3c" / "#fff" into { r, g, b }; returns null for anything that
// isn't a plain hex color (e.g. a CSS variable), so callers can still pass one.
const hexToRgb = (hex) => {
  if (typeof hex !== "string") return null;
  const match = /^#?([0-9a-f]{3}|[0-9a-f]{6})$/i.exec(hex.trim());
  if (!match) return null;
  const value = match[1].length === 3
    ? match[1].split("").map((char) => char + char).join("")
    : match[1];
  const int = parseInt(value, 16);
  return { r: (int >> 16) & 255, g: (int >> 8) & 255, b: int & 255 };
};

// One shared "← Games" button for every game's header. It adapts to each game's
// theme via the `accent` colour: the chevron chip, hard drop-shadow, and focus
// ring are all derived from it. On narrow screens it collapses to a tidy
// chevron-only square. Pass `className`/`style` for header-specific positioning.
const BackToGamesButton = ({
  onClick,
  label = "Games",
  accent = "#2A6FD8",
  ariaLabel = "Back to games",
  className = "",
  style,
}) => {
  const rgb = hexToRgb(accent);
  const themeVars = rgb
    ? {
        "--btg-accent": accent,
        "--btg-accent-soft": `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, 0.14)`,
        "--btg-shadow": `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, 0.24)`,
        "--btg-ring": `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, 0.42)`,
      }
    : { "--btg-accent": accent };

  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={ariaLabel}
      className={`back-to-games${className ? ` ${className}` : ""}`}
      style={{ ...themeVars, ...style }}
    >
      <span aria-hidden="true" className="back-to-games__chip">←</span>
      <span className="back-to-games__label">{label}</span>
    </button>
  );
};

export default BackToGamesButton;
